module.exports = __webpack_public_path__ + "assets/images/50L.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/50L.png
// module id = 1305
// module chunks = 1